import { takeEvery } from 'redux-saga/effects';
import {
  PIN_VIDEO,
  UNPIN_VIDEO,
  REQUEST_SAVED_VIDEOS_COLLECTION,
  REQUEST_SAVED_VIDEOS_MOBILE_COLLECTION,
} from './actions';

import { pinVideoEffect, unpinVideoEffect, requestSavedVideosEffect, requestSavedVideosMobileEffect } from './effects';

export const savedVideosSaga = function* () {
  yield takeEvery(PIN_VIDEO, pinVideoEffect);
  yield takeEvery(UNPIN_VIDEO, unpinVideoEffect);
  yield takeEvery(REQUEST_SAVED_VIDEOS_COLLECTION, requestSavedVideosEffect);
  yield takeEvery(REQUEST_SAVED_VIDEOS_MOBILE_COLLECTION, requestSavedVideosMobileEffect);
};
